"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthDayItem = void 0;
const react_1 = __importStar(require("react"));
const SelectableItem_1 = require("../../../../../helpers/components/SelectableItem/SelectableItem");
exports.MonthDayItem = react_1.default.memo(({ date, value, isDayDisabled, onSelect, highlightDays, showCurrentDate, now, year, month }) => {
    const getDate = (0, react_1.useMemo)(() => date.getDate(), [date]);
    const isDisabled = (0, react_1.useMemo)(() => (isDayDisabled ? isDayDisabled(date) : false), [date, isDayDisabled]);
    const isSelected = (0, react_1.useMemo)(() => value &&
        date.getFullYear() === value.getFullYear() &&
        date.getMonth() === value.getMonth() &&
        date.getDate() === value.getDate(), [date, value]);
    const isCurrentMonth = (0, react_1.useMemo)(() => date.getFullYear() === year && date.getMonth() === month, [date, month, year]);
    const isToday = (0, react_1.useMemo)(() => date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate(), [date, now]);
    const isHighlighted = (0, react_1.useMemo)(() => (highlightDays ? highlightDays.includes(date.toDateString()) : false), [date, highlightDays]);
    const handleOnClick = (0, react_1.useCallback)(() => {
        if (onSelect) {
            onSelect(date);
        }
    }, [date, onSelect]);
    return (react_1.default.createElement(SelectableItem_1.SelectableItem, { value: getDate, disabled: isDisabled, onClick: handleOnClick, selected: isSelected, isCurrentMonth: isCurrentMonth, isToday: isToday, isHighlighted: isHighlighted, showCurrentDate: showCurrentDate }));
});
exports.MonthDayItem.displayName = 'MonthDayItem';
//# sourceMappingURL=MonthDayItem.js.map